module.exports = __webpack_public_path__ + "img/GO_05.e6645a70.png";